import Dropdown from 'react-bootstrap/Dropdown';
import { forwardRef, useState } from 'react';
import DeleteDraftModal from '../../components/DeleteDraftModal';

function DeleteDraftDropdown({ id }) {
  const [deleteDraftModalShow, setDeleteDraftModalShow] = useState(false);

  const CustomToggle = forwardRef(({ children, onClick }, ref) => (
    <Dropdown.Toggle
      ref={ref}
      variant='secondary-black'
      className='p-2'
      style={{
        fontSize: '12px',
        fontWeight: 'bold',
        lineHeight: '12px',
        color: 'white',
      }}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
    </Dropdown.Toggle>
  ));

  return (
    <>
      <Dropdown id='dropdown-basic-button' size='sm'>
        <Dropdown.Toggle as={CustomToggle}>Utkast</Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item
            onClick={() => {
              setDeleteDraftModalShow(true);
            }}
          >
            Radera utkast
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      <DeleteDraftModal
        competitionId={id}
        show={deleteDraftModalShow}
        onHide={() => setDeleteDraftModalShow(false)}
      />
    </>
  );
}

export default DeleteDraftDropdown;
